<input
	[disabled]="isDateTimeDisabled"
	class="text fullsize"
	type="text"
	[placeholder]="placeholder()"
	(focus)="onFocus($event)"
	[id]="inputId"
	[attr.aria-label]="ariaLabel()"
	#flatpickr
/>
@if (!isMobileDevice) {
	<label class="icon-label" [for]="inputId"
		><i class="ico ico-calendar" [ngClass]="{ disabled: isDateTimeDisabled }"></i
	></label>
}
